import { Autocomplete as AutocompleteMui } from '@mui/material';

import styled from 'styled-components';

const StyledAutocomplete = styled(AutocompleteMui)``;

export default StyledAutocomplete;
